export default {
	in: 'In',
	out: 'Out'
}